import React from 'react'
import UpdateVirtualCard from 'src/app/UpdateVirtualCard/UpdateVirtualCard'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { updateVirtualCardRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const UpdateVirtualCardAppRoute: AppRoute = {
  id: AppLocation.UpdateVirtualCard,
  routeProps: updateVirtualCardRouteProps,
  component: <UpdateVirtualCard />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default UpdateVirtualCardAppRoute
